<template>
  <div class="flex flex-col">
    <TotalEarnings />
    <ProductSold class="mt-4" />
    <div class="flex justify-between">
      <NewCustomers class="items-start" />
      <div class="orders flex flex-col">
        <TotalOrders class="mb-4" />
        <TotalUploadedProducts />
      </div>
    </div>
  </div>

</template>

<script>
import TotalEarnings from './includes/three_quarter/TotalEarnings.vue';
import ProductSold from './includes/one_quarter/ProductSold.vue';
import NewCustomers from './includes/three_quarter/NewCustomers.vue';
import TotalOrders from './includes/three_quarter/TotalOrders.vue';
import TotalUploadedProducts from './includes/three_quarter/TotalUploadedProducts.vue';

export default {
  name: 'charts',
  components: {
    TotalEarnings,
    ProductSold,
    NewCustomers,
    TotalOrders,
    TotalUploadedProducts,
  },
};
</script>

<style scoped>
.orders {
  flex: 0 1 49%;
}
</style>
